// SoClose Pte. Ltd. -- Singapore legal & branding constants (ported from the SoClose branding kit).
// Use this everywhere instead of hardcoding company info.
export const SOCLOSE = {
  name: "SoClose Pte. Ltd.",
  shortName: "SoClose",
  uen: "202555665W",
  uenLabel: "UEN 202555665W",
  registrationDate: "2025-12-16",
  legalForm: "Exempt Private Company Limited by Shares",
  jurisdiction: "Singapore",
  jurisdictionFlag: "SG",
  address: {
    line1: "Suntec Tower One",
    line2: "7 Temasek Boulevard, #12-007",
    postal: "038987",
    city: "Singapore",
    country: "Singapore",
    full: "Suntec Tower One, 7 Temasek Boulevard, #12-007, Singapore 038987",
  },
  contact: {
    email: "contact@soclose.co",
    phone: "+66 64 027 21 21",
    phoneRaw: "+66640272121",
    website: "https://soclose.co",
  },
  business: {
    primary: "Development of software and applications",
    secondary: "Advertising activities",
  },
  // PDPA = Personal Data Protection Act (Singapore equivalent of GDPR)
  privacy: {
    framework: "PDPA",
    frameworkFull: "Singapore Personal Data Protection Act 2012 (PDPA)",
    authority: "Personal Data Protection Commission (PDPC)",
    authorityUrl: "https://www.pdpc.gov.sg/",
  },
  currency: {
    code: "SGD",
    symbol: "S$",
    name: "Singapore Dollar",
  },
} as const;

export const SOCLOSE_FX: Record<string, number> = {
  EUR_TO_SGD: 1.42,
  USD_TO_SGD: 1.3,
  THB_TO_SGD: 0.038,
};

export const SG_FLAG = String.fromCodePoint(0x1f1f8, 0x1f1ec);

type FmtOpts = { round?: boolean };

// Format a SGD price for display. formatSGD(29) => "S$ 29"; formatSGD(29.5, {round:false}) => "S$ 29.50"
export function formatSGD(amount: number, { round = true }: FmtOpts = {}): string {
  const symbol = SOCLOSE.currency.symbol;
  if (round) return `${symbol} ${Math.round(amount).toLocaleString("en-SG")}`;
  return `${symbol} ${amount.toLocaleString("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// Convert from EUR/USD/THB to SGD using fixed rates. toSGD(20, "EUR") => 28.4
export function toSGD(amount: number, fromCurrency = "EUR"): number {
  const rate = SOCLOSE_FX[`${fromCurrency.toUpperCase()}_TO_SGD`];
  if (!rate) return amount;
  return amount * rate;
}

// One-step: convert + format. priceInSGD(19, "EUR") => "S$ 27"
export function priceInSGD(amount: number, fromCurrency = "EUR", opts?: FmtOpts): string {
  return formatSGD(toSGD(amount, fromCurrency), opts);
}
